import { useAppSelector } from '@/state/store';
import { useMemo } from 'react';

export function useLocations() {
    const { locations, isFetchingLocations, areas, isFetchingAreas, regions, isFetchingRegions } = useAppSelector(
        (state) => state.app,
    );

    const isLoading = isFetchingLocations || isFetchingAreas || isFetchingRegions;

    return {
        locations,
        areas,
        regions,
        isLoading,
    };
}

export function useLocation(locationId: string) {
    const { locations } = useAppSelector((state) => state.app);

    const location = locations[locationId];

    return useMemo(() => location, [location]);
}
